import React from 'react';
import classNames from 'classnames';
import { LinearProgress } from '@material-ui/core';

import styles from './ProgressBar.module.scss';

type PropsType = {
  progress: number;
  classes?: ClassesType;
};
type ClassesType = { root?: string; progressBar?: string };

export default function ProgressBar({
  progress,
  classes,
}: PropsType): JSX.Element {
  return (
    <LinearProgress
      variant="determinate"
      value={progress}
      classes={{
        root: classNames(styles.root, classes?.root),
        barColorPrimary: classNames(styles.progressBar, classes?.progressBar),
      }}
    />
  );
}
